export default __webpack_public_path__ + "static/media/features3.42622271.jpg";